import React, { useEffect, useMemo, useState } from "react";
import Layout from "../../Shared/Layout";
import {
    Grid,
    Collapse,
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    InputLabel,
    Select, TextField,
} from "@material-ui/core";
import styled from "styled-components";
import { Inertia } from "@inertiajs/inertia";
import { Field, Form as FinalForm } from "react-final-form";
import TextInput from "../../Shared/TextInput";
import { getCookieValue } from "../../utils/getCookieValue";
import { Trans } from "../../utils/i18n";
import { Alert } from "@material-ui/lab";
import Wrapper from "./Wrapper";
import dayjs from "dayjs";
import {Button, Modal} from "@mui/material";
import CloseIcon from "@material-ui/icons/Close";
import {ModalContent} from "../../Shared/ProductSelectDynamic";
import EditIcon from "@material-ui/icons/Edit";
import FormControl from "@material-ui/core/FormControl";
import {useForm} from "@inertiajs/inertia-react";
import {DateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {format, isToday, parse} from "date-fns";
import DateTimepicker from "../../Shared/DateTimepicker";
import {getAppointmentStatusTranslation} from "../../utils/appointmentUtils";



const HR = styled.hr`
    display: flex;
    justify-content: flex-end;
    margin: 15px 0;
`;

const ResponseWrapper = styled.div`
    width: 100%;
    margin-top: 30px;
`;

export default function Appointments({
    client,
    order,
    statuses,
    appointments,
    services,
    partners,
    coverages,
    settlements,
    materialOperations,
    files,
    userCanUpdate,
    orderattributes,
    orderhistories,
    extendedMode,
    permissions,
    returnUrl,
                                     orderdetailsWithTerminalId,
}) {
    const [modalOpen, setModalOpen] = useState(false);
    const [createModal, setCreateModal] = useState(false);
    const [newStatus, setNewStatus] = useState(null);

    const {data, setData, post, errors, cha} = useForm({
        status: "completed",
        orderdetail_id: orderdetailsWithTerminalId[0]?.id,
        order_id: order.order_id,
        date: format((new Date()), 'dd.MM.yyyy HH:mm'),
        company: order?.delivery_address?.name,
        name: order?.delivery_address?.name_2,
        phone: order?.delivery_address?.phone,
        email: order?.delivery_address?.email,
    });
    const handleSubmit = (e) => {
        e.preventDefault();
        post(route('queue.appointment.create'), {
            onSuccess: () => {
                setCreateModal(false);
            },
        });
    }
    const dateValue = data.date ? parse(data.date, 'dd.MM.yyyy HH:mm', new Date()) : data.date === 'error' ? 'error' : null;

    return (
        <Wrapper>
            <HR />
            <h3 className={'flex justify-between items-center'}>
                <Trans i18nKey="queueDetail.tabs.appointments">Appointments</Trans>
                <Button variant={'outlined'} color={'secondary'} size="small" onClick={() => {
                    setCreateModal(true);
                }}>
                    <Trans i18nKey="common.add">Add</Trans>
                </Button>
            </h3>

            <TableContainer>
                <Table
                    size="small"
                    aria-label={
                        <Trans i18nKey="queueDetail.collapsibleTable">
                            collapsible table
                        </Trans>
                    }
                >
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <Trans i18nKey="common.date">Date</Trans>
                            </TableCell>
                            <TableCell>
                                <Trans i18nKey="common.status">Status</Trans>
                            </TableCell>
                            <TableCell><Trans i18nKey="queues.tid">Terminal ID</Trans></TableCell>
                            <TableCell>
                                <Trans i18nKey="queues.company">Company</Trans>
                            </TableCell>
                            <TableCell>
                                <Trans i18nKey="orderEntry.addressContact.contact_name">Contact name</Trans>
                            </TableCell>
                            <TableCell>
                                <Trans i18nKey="appointment.form.phoneNumber">Phone number</Trans>
                            </TableCell>
                            <TableCell>
                                <Trans i18nKey="appointments.cashRegisterConnection">Cash register connection</Trans>
                            </TableCell>
                            <TableCell>
                                <Trans i18nKey="appointment.form.email">E-Mail Address</Trans>
                            </TableCell>
                            <TableCell>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {appointments.map((product) => (
                            <>
                                <TableRow key={product.id}>
                                    <TableCell
                                        component="th"
                                        scope="row"
                                    >
                                        { dayjs(product.timeslot?.start_time ?? product.start_time).format('DD.MM.YYYY HH:mm') }
                                        { !!product.timeslot && ' - '}
                                        { !!product.timeslot && dayjs(product.timeslot?.end_time).format('HH:mm') }
                                    </TableCell>
                                    <TableCell>
                                        {
                                            getAppointmentStatusTranslation(product)
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {product.tid}
                                    </TableCell>
                                    <TableCell>
                                        {product.company}
                                    </TableCell>
                                    <TableCell>
                                        {product.name}
                                    </TableCell>
                                    <TableCell>
                                        {product.phone}
                                    </TableCell>
                                    <TableCell>
                                        {product.cash_register_connection !== null ? (product.cash_register_connection ? <Trans i18nKey="common.yes">Yes</Trans> : <Trans i18nKey="common.no">No</Trans>) : '' }
                                    </TableCell>
                                    <TableCell>
                                        {product.email}
                                    </TableCell>
                                    <TableCell>
                                        <IconButton
                                            onClick={() => {
                                                setModalOpen(product);
                                                setNewStatus(product.status);
                                            }}>
                                            <EditIcon/>
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            </>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {
                createModal &&
                    <Modal
                        open={true}
                        onClose={() => {
                            setCreateModal(false);
                        }}
                    >
                        <ModalContent>
                            <IconButton
                                aria-label="delete"
                                onClick={() => {
                                    setCreateModal(false);
                                }}
                                style={{
                                    position: 'absolute',
                                    top: '1.5rem',
                                    right: '1.5rem',
                                }}
                            >
                                <CloseIcon/>
                            </IconButton>
                            <h3>
                                <Trans i18nKey="queues.appointment.add">
                                    Add appointment
                                </Trans>
                            </h3>
                            <div className={'mt-9'}>
                                <form onSubmit={handleSubmit}>
                                    <div className={'mt-6'}>
                                        <FormControl
                                            variant="outlined"
                                        >
                                            <InputLabel id="filter-client">
                                                <Trans i18nKey="queues.tid">Terminal ID</Trans>
                                            </InputLabel>
                                            <Select
                                                labelId="filter-client"
                                                label={
                                                    <Trans i18nKey="queues.tid">Terminal ID</Trans>
                                                }
                                                value={data?.orderdetail_id}
                                                onChange={(e, val) => {
                                                    setData('orderdetail_id', e.target.value);
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                }}
                                                native
                                                error={!!errors?.orderdetail_id}
                                                helperText={errors?.orderdetail_id}
                                            >
                                                {
                                                    orderdetailsWithTerminalId.map((item) => (
                                                        <option value={item.id} key={item.id}>
                                                            {item.tid}
                                                        </option>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                        <HR/>
                                    </div>
                                    <div>
                                        <DateTimepicker
                                            field={{
                                                label: <Trans i18nKey="queueDetail.appointmentDate">Appointment
                                                    date</Trans>
                                            }}
                                            input={{
                                                value: data.date,
                                                onChange: (value) => {
                                                    setData('date', value);
                                                },
                                            }}
                                            meta={{}}
                                        >

                                        </DateTimepicker>
                                    </div>
                                    <div className={'mt-6'}>
                                        <FormControl
                                            variant="outlined"
                                        >
                                            <InputLabel id="filter-client">
                                                <Trans i18nKey="common.status">
                                                    Status
                                                </Trans>
                                            </InputLabel>
                                            <Select
                                                labelId="filter-client"
                                                label={
                                                    <Trans i18nKey="common.status">
                                                        Status
                                                    </Trans>
                                                }
                                                value={data?.status}
                                                onChange={(e, val) => {
                                                    setData('status', e.target.value);
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                }}
                                                native
                                                error={!!errors?.status}
                                                helperText={errors?.status}
                                            >
                                                <option value={'open'}>
                                                    <Trans i18nKey="appointment.status.open">Open</Trans>
                                                </option>
                                                <option value={'customerNotAvailable'}>
                                                    <Trans i18nKey="appointment.status.customerNotAvailable">Customer
                                                        was not
                                                        available</Trans>
                                                </option>
                                                <option value={'completed'}>
                                                    <Trans i18nKey="appointment.status.completed">Completed</Trans>
                                                </option>
                                                <option value={'cancelled'}>
                                                    <Trans i18nKey="appointment.status.cancelled">Cancelled</Trans>
                                                </option>
                                                <option value={'failed'}>
                                                    <Trans i18nKey="appointment.status.failed">Failed</Trans>
                                                </option>
                                                <option value={'Back2Sales'}>
                                                    <Trans i18nKey="appointment.status.Back2Sales">Back2Sales</Trans>
                                                </option>
                                            </Select>
                                        </FormControl>
                                        <HR/>
                                    </div>
                                    <div className={'mt-6'}>
                                        <TextField
                                            id="company"
                                            name="company"
                                            label={<Trans i18nKey="queues.company">Company</Trans>}
                                            value={data.company}
                                            onChange={(e) => setData("company", e.target.value || "")}
                                            variant="outlined"
                                            type="text"
                                        />
                                        <HR/>
                                    </div>
                                    <div className={'mt-6'}>
                                        <TextField
                                            id="name"
                                            name="name"
                                            label={<Trans i18nKey="orderEntry.addressContact.contact_name">Contact
                                                name</Trans>}
                                            value={data.name}
                                            onChange={(e) => setData("name", e.target.value || "")}
                                            variant="outlined"
                                            type="text"
                                        />
                                        <HR/>
                                    </div>
                                    <div className={'mt-6'}>
                                        <TextField
                                            id="phone"
                                            name="phone"
                                            label={<Trans i18nKey="orderEntry.addressContact.phone">Phone</Trans>}
                                            value={data.phone}
                                            onChange={(e) => setData("phone", e.target.value || "")}
                                            variant="outlined"
                                            type="text"
                                        />
                                        <HR/>
                                    </div>
                                    <div className={'mt-6'}>
                                        <TextField
                                            id="email"
                                            name="email"
                                            label={<Trans i18nKey="appointment.form.email">E-Mail Address</Trans>}
                                            value={data.email}
                                            onChange={(e) => setData("email", e.target.value || "")}
                                            variant="outlined"
                                            type="email"
                                        />
                                        <HR/>
                                    </div>
                                    <div className={'mt-6'}>
                                        <FormControl
                                            variant="outlined"
                                        >
                                            <InputLabel id="filter-client">
                                                <Trans i18nKey="appointments.cashRegisterConnection">Cash register
                                                    connection</Trans>
                                            </InputLabel>
                                            <Select
                                                labelId="filter-client"
                                                label={
                                                    <Trans i18nKey="appointments.cashRegisterConnection">Cash register
                                                        connection</Trans>
                                                }
                                                value={data?.cash_register_connection}
                                                onChange={(e, val) => {
                                                    setData('cash_register_connection', e.target.value);
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                }}
                                                native
                                                error={!!errors?.cash_register_connection}
                                                helperText={errors?.cash_register_connection}
                                            >
                                                <option>
                                                </option>
                                                <option value={'yes'}>
                                                    <Trans i18nKey="appointments.cashRegisterConnection.yes">Yes, a cash
                                                        register connection is required</Trans>
                                                </option>
                                                <option value={'no'}>
                                                    <Trans i18nKey="appointments.cashRegisterConnection.no">No, not
                                                        required</Trans>
                                                </option>
                                            </Select>
                                        </FormControl>
                                        <HR/>
                                    </div>

                                    <ResponseWrapper>
                                        {errors && Object.values(errors).map(item => (
                                            <div className={"mb-3"} key={item}>
                                                <Alert severity="warning">
                                                    {item}
                                                </Alert>
                                            </div>
                                        ))}
                                    </ResponseWrapper>
                                    <div className={'w-full flex justify-end mt-6'}>
                                        <Button
                                            variant={'contained'}
                                            color={'secondary'}
                                            type={'submit'}
                                        >
                                            <Trans i18nKey="common.save">
                                                Save
                                            </Trans>
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </ModalContent>
                    </Modal>
            }
            {
                modalOpen &&
                <Modal
                    open={true}
                    onClose={() => {
                        setModalOpen(false);
                    }}
                >
                    <ModalContent>
                        <IconButton
                            aria-label="delete"
                            onClick={() => {
                                setModalOpen(false);
                            }}
                            style={{
                                position: 'absolute',
                                top: '1.5rem',
                                right: '1.5rem',
                            }}>
                            <CloseIcon/>
                        </IconButton>
                        <div className={'mt-9'}>
                            <FormControl
                                variant="outlined"
                            >
                                <InputLabel id="filter-client">
                                    <Trans i18nKey="common.status">
                                        Status
                                    </Trans>
                                </InputLabel>
                                <Select
                                    labelId="filter-client"
                                    label={
                                        <Trans i18nKey="common.status">
                                            Status
                                        </Trans>
                                    }
                                    value={newStatus}
                                    onChange={(e, val) => {
                                        setNewStatus(e.target.value);
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }}
                                    native
                                >
                                    <option value={'open'}>
                                        <Trans i18nKey="appointment.status.open">Open</Trans>
                                    </option>
                                    <option value={'customerNotAvailable'}>
                                        <Trans i18nKey="appointment.status.customerNotAvailable">Customer was not
                                            available</Trans>
                                    </option>
                                    <option value={'completed'}>
                                        <Trans i18nKey="appointment.status.completed">Completed</Trans>
                                    </option>
                                    <option value={'cancelled'}>
                                        <Trans i18nKey="appointment.status.cancelled">Cancelled</Trans>
                                    </option>
                                    <option value={'failed'}>
                                        <Trans i18nKey="appointment.status.failed">Failed</Trans>
                                    </option>
                                </Select>
                            </FormControl>
                            <div className={'w-full flex justify-end mt-6'}>
                                <Button
                                    variant={'contained'}
                                    color={'secondary'}
                                    onClick={() => {
                                        Inertia.put(route('appointment.update', {appointment: modalOpen.id}), {
                                            status: newStatus,
                                        }, {
                                            onSuccess: () => {
                                                setModalOpen(false);
                                            }
                                        });
                                    }}
                                >
                                    <Trans i18nKey="common.save">
                                        Save
                                    </Trans>
                                </Button>
                            </div>
                        </div>
                    </ModalContent>
                </Modal>
            }
        </Wrapper>
    );
}

Appointments.layout = (page) => <Layout children={page}/>;
